import React, { lazy, Suspense } from 'react';
import { Spinner } from 'xm-spark';

export default function lazyLoad(loadableFn, opts = {}) {
  const fallback =
    opts.fallback === undefined ? <Spinner centered /> : opts.fallback;
  const LazyComponent = lazy(loadableFn);

  const LazyLoader = props => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );

  LazyLoader.displayName = 'LazyLoader';

  return LazyLoader;
}

export function lazyLoadNoSpinner(loadableFn, opts) {
  return lazyLoad(loadableFn, { fallback: null, ...opts });
}
